import React, { useState } from 'react';
import { useOrder } from '../../context/OrderContext';
import { RALModal } from '../../modals';

// Helper to check if finish requires RAL code
const isSpecialFinish = (code) => code === 'V1' || code === 'V2';

// Profile-specific coprifilo configurations
const PROFILE_CONFIGS = {
    '6': {
        label: 'NINFA 6',
        profileImage: '/images/profiles/N6.png',
        types: [
            { value: 'standard', label: 'Coprifilo Standard', baseCode: 'N6-CF-2F', image: '/images/accessories/COPRIFILO/PRIMO STEP/SEL-CF-N6.png' }
        ],
        glassOptions: [
            { value: '10+10', label: 'Vetro 10+10', guarnizione: 'N6-G1' }
        ]
    },
    '106': {
        label: 'NINFA 106',
        profileImage: '/images/profiles/N106.png',
        types: [
            { value: 'standard', label: 'Coprifilo Standard', baseCode: 'N6-CF-2', image: '/images/accessories/COPRIFILO/PRIMO STEP/SEL-CF-N106.png' }
        ],
        glassOptions: [
            { value: '8+8', label: 'Vetro 8+8', guarnizione: 'N6-G2' },
            { value: '10+10', label: 'Vetro 10+10', guarnizione: 'N6-G1' }
        ]
    },
    '116': {
        label: 'NINFA 116',
        profileImage: '/images/profiles/N116.png',
        types: [
            { value: 'standard', label: 'Coprifilo Standard', baseCode: 'N6-CF-2', image: '/images/accessories/COPRIFILO/PRIMO STEP/SEL-CF-N116.png' }
        ],
        glassOptions: [
            { value: '8+8', label: 'Vetro 8+8', guarnizione: 'N6-G2' },
            { value: '10+10', label: 'Vetro 10+10', guarnizione: 'N6-G1' }
        ]
    },
    '176': {
        label: 'NINFA 176',
        profileImage: '/images/profiles/N176.png',
        types: [
            { value: 'cf1', label: 'Coprifilo NINFA 176', baseCode: 'N6-CF-1', supportsSupplyType: true, image: '/images/accessories/COPRIFILO/PRIMO STEP/SEL-CF-N176.png' },
            { value: 'cf2', label: 'Coprifilo NINFA 186', baseCode: 'N6-CF-2', supportsSupplyType: true, image: '/images/accessories/COPRIFILO/PRIMO STEP/SEL-CF-N186.png' },
            { value: 'cf2f', label: 'Coprifilo NINFA 186 (2F)', baseCode: 'N6-CF-2F', supportsSupplyType: true, image: '/images/accessories/COPRIFILO/PRIMO STEP/SEL-CF-N6.png' },
            { value: 'cfl1', label: 'Coprifilo Asolato NINFA 176', baseCode: 'N6-CFL-1', supportsSupplyType: false, fixedLength: 2000, image: '/images/accessories/COPRIFILO/PRIMO STEP/SEL-CF-N176.png' },
            { value: 'cfl2', label: 'Coprifilo Asolato NINFA 186', baseCode: 'N6-CFL-2', supportsSupplyType: false, fixedLength: 2000, image: '/images/accessories/COPRIFILO/PRIMO STEP/SEL-CF-N186.png' },
            { value: 'cfl2f', label: 'Coprifilo Asolato NINFA 186 (2F)', baseCode: 'N6-CFL-2F', supportsSupplyType: false, fixedLength: 2000, image: '/images/accessories/COPRIFILO/PRIMO STEP/SEL-CF-N6.png' }
        ],
        glassOptions: {
            'cf1': [
                { value: 'none', label: 'Senza vetro specificato', guarnizione: 'N6-G1', autoAdd: true }
            ],
            'cf2': [
                { value: '10+10', label: 'Vetro 10+10', guarnizione: 'N6-G2' },
                { value: '12+12', label: 'Vetro 12+12', guarnizione: 'N6-G1' }
            ],
            'cf2f': [
                { value: '8+8', label: 'Vetro 8+8', guarnizione: 'N6-G2' }
            ],
            'cfl1': [
                { value: 'none', label: 'Senza vetro specificato', guarnizione: 'N6-G1', autoAdd: true }
            ],
            'cfl2': [
                { value: '10+10', label: 'Vetro 10+10', guarnizione: 'N6-G2' },
                { value: '12+12', label: 'Vetro 12+12', guarnizione: 'N6-G1' }
            ],
            'cfl2f': [
                { value: '8+8', label: 'Vetro 8+8', guarnizione: 'N6-G2' }
            ]
        }
    },
    '186': {
        label: 'NINFA 186',
        profileImage: '/images/profiles/N186.png',
        types: [
            { value: 'cf1', label: 'Coprifilo NINFA 176', baseCode: 'N6-CF-1', supportsSupplyType: true, image: '/images/accessories/COPRIFILO/PRIMO STEP/SEL-CF-N176.png' },
            { value: 'cf2', label: 'Coprifilo NINFA 186', baseCode: 'N6-CF-2', supportsSupplyType: true, image: '/images/accessories/COPRIFILO/PRIMO STEP/SEL-CF-N186.png' },
            { value: 'cf2f', label: 'Coprifilo NINFA 186 (2F)', baseCode: 'N6-CF-2F', supportsSupplyType: true, image: '/images/accessories/COPRIFILO/PRIMO STEP/SEL-CF-N6.png' },
            { value: 'cfl1', label: 'Coprifilo Asolato NINFA 176', baseCode: 'N6-CFL-1', supportsSupplyType: false, fixedLength: 2000, image: '/images/accessories/COPRIFILO/PRIMO STEP/SEL-CF-N176.png' },
            { value: 'cfl2', label: 'Coprifilo Asolato NINFA 186', baseCode: 'N6-CFL-2', supportsSupplyType: false, fixedLength: 2000, image: '/images/accessories/COPRIFILO/PRIMO STEP/SEL-CF-N186.png' },
            { value: 'cfl2f', label: 'Coprifilo Asolato NINFA 186 (2F)', baseCode: 'N6-CFL-2F', supportsSupplyType: false, fixedLength: 2000, image: '/images/accessories/COPRIFILO/PRIMO STEP/SEL-CF-N6.png' }
        ],
        glassOptions: {
            'cf1': [
                { value: 'none', label: 'Senza vetro specificato', guarnizione: 'N6-G1', autoAdd: true }
            ],
            'cf2': [
                { value: '10+10', label: 'Vetro 10+10', guarnizione: 'N6-G2' },
                { value: '12+12', label: 'Vetro 12+12', guarnizione: 'N6-G1' }
            ],
            'cf2f': [
                { value: '8+8', label: 'Vetro 8+8', guarnizione: 'N6-G2' }
            ],
            'cfl1': [
                { value: 'none', label: 'Senza vetro specificato', guarnizione: 'N6-G1', autoAdd: true }
            ],
            'cfl2': [
                { value: '10+10', label: 'Vetro 10+10', guarnizione: 'N6-G2' },
                { value: '12+12', label: 'Vetro 12+12', guarnizione: 'N6-G1' }
            ],
            'cfl2f': [
                { value: '8+8', label: 'Vetro 8+8', guarnizione: 'N6-G2' }
            ]
        }
    }
};

// Available finishes
const FINISH_OPTIONS = [
    { code: 'A', name: 'Argento', suffix: 'A', color: '#C0C0C0' },
    { code: 'B', name: 'RAL9010 Opaco', suffix: 'B', color: '#FFFFFF' },
    { code: 'G', name: 'Grezzo', suffix: 'G', color: '#E0E0E0' },
    { code: 'N', name: 'RAL9005 Opaco', suffix: 'N', color: '#000000' },
    { code: 'V1', name: 'Verniciato Speciale 1', suffix: 'V1', color: '#D3D3D3' },
    { code: 'V2', name: 'Verniciato Speciale 2', suffix: 'V2', color: '#B8B8B8' }
];

// Supply type options
const SUPPLY_TYPE_OPTIONS = [
    { value: '3m', label: 'Barre da 3 Metri', icon: '3M' },
    { value: '6m', label: 'Barre da 6 Metri', icon: '6M' },
    { value: 'misura', label: 'Tagliato a Misura', icon: 'M' }
];

export const CoverStripSelector = ({ onSelect, initialValues = {}, isEditMode = false, profileType: propProfileType }) => {
    const { state } = useOrder();
    // Use profileType from props or fall back to order state
    const profileType = propProfileType || state?.orderDetails?.profileType || state?.orderDetails?.ninfaNumber;

    // Normalize profile type to extract number only
    const normalizedProfileType = profileType ? profileType.toString().replace(/^N/, '') : null;

    // State management
    const [step, setStep] = useState(normalizedProfileType ? 2 : 1); // Skip profile selection if already known
    const [selectedProfile, setSelectedProfile] = useState(normalizedProfileType || initialValues?.selectedProfile || null);
    const [selectedType, setSelectedType] = useState(initialValues?.selectedType || null);
    const [supplyType, setSupplyType] = useState(initialValues?.supplyType || '');
    const [finish, setFinish] = useState(initialValues?.finish || '');
    const [ralCode, setRalCode] = useState(initialValues?.ralCode || null);
    const [glassThickness, setGlassThickness] = useState(initialValues?.glassThickness || '');
    const [quantity, setQuantity] = useState(initialValues?.quantity || 1);
    const [customBars, setCustomBars] = useState(initialValues?.customBars || []);
    const [needsKitDistanziale, setNeedsKitDistanziale] = useState(initialValues?.needsKitDistanziale || false);

    // RAL Modal state
    const [showRALModal, setShowRALModal] = useState(false);
    const [pendingFinishCode, setPendingFinishCode] = useState(null);

    // Get current profile configuration
    const profileConfig = selectedProfile ? PROFILE_CONFIGS[selectedProfile] : null;

    // Get glass options based on selected type
    const getGlassOptions = () => {
        if (!profileConfig || !selectedType) return [];

        const glassOpts = profileConfig.glassOptions;

        // For profiles 176 and 186, glass options depend on the type
        if (typeof glassOpts === 'object' && !Array.isArray(glassOpts)) {
            return glassOpts[selectedType.value] || [];
        }

        // For simpler profiles, return the array directly
        return glassOpts;
    };

    // Check if selected type is "Asolato" (CFL variants)
    const isAsolatoType = () => {
        return selectedType && selectedType.value && selectedType.value.startsWith('cfl');
    };

    // Step 1: Profile selection (only if profile not specified)
    const handleProfileSelect = (profileKey) => {
        setSelectedProfile(profileKey);
        setSelectedType(null); // Reset type when profile changes
        setStep(2); // Go to type selection
    };

    // Step 2: Type selection
    const handleTypeSelect = (type) => {
        setSelectedType(type);

        // For CFL types (asolato) with fixed length, skip supply type selection
        if (!type.supportsSupplyType && type.fixedLength) {
            setSupplyType('fixed-2m'); // Set a special supply type for fixed 2m pieces
            setStep(4); // Go directly to finish selection
        } else {
            setStep(3); // Go to supply type selection
        }
    };

    // Step 3: Supply type selection
    const handleSupplyTypeSelect = (supplyTypeValue) => {
        setSupplyType(supplyTypeValue);

        if (supplyTypeValue === 'misura') {
            setStep(7); // Go to custom bars input
        } else {
            setStep(4); // Go to finish selection for barre
        }
    };

    // Step 4: Finish selection
    const handleFinishSelect = (finishCode) => {
        if (isSpecialFinish(finishCode)) {
            // Show RAL modal for V1/V2
            setPendingFinishCode(finishCode);
            setShowRALModal(true);
        } else {
            setFinish(finishCode);
            setRalCode(null);
            setStep(5); // Go to glass selection
        }
    };

    // Handle RAL confirmation
    const handleRALConfirm = (code) => {
        setShowRALModal(false);
        setFinish(pendingFinishCode);
        setRalCode(code);
        setPendingFinishCode(null);
        setStep(5); // Go to glass selection
    };

    // Handle RAL modal close
    const handleRALClose = () => {
        setShowRALModal(false);
        setPendingFinishCode(null);
    };

    // Step 5: Glass thickness selection
    const handleGlassSelect = (glass) => {
        setGlassThickness(glass);

        // For NINFA 186 asolato types, ask about kit distanziale
        if (selectedProfile === '186' && isAsolatoType()) {
            setStep(9); // Go to kit distanziale selection
        } else {
            setStep(6); // Go to quantity configuration
        }
    };

    // Step 6: Quantity configuration (only for barre)
    const handleQuantityChange = (e) => {
        const raw = e.target.value;
        if (raw === '') {
            setQuantity('');
            return;
        }
        const value = parseInt(raw) || 1;
        setQuantity(Math.max(1, value));
    };

    // Generate product codes based on selections
    const generateProductCodes = () => {
        const products = [];

        if (!selectedType || !finish || !selectedProfile) return products;

        // Get finish config
        const finishConfig = FINISH_OPTIONS.find(f => f.code === finish);

        // Build base code
        let finalCode = `${selectedType.baseCode}${finishConfig?.suffix || ''}`;

        // Add T suffix for tagliato a misura
        if (supplyType === 'misura') {
            finalCode = finalCode + 'T';
        }

        // Calculate quantity based on supply type
        let finalQuantity = quantity;
        let guarnizioneQuantity = quantity; // Separate quantity for guarnizione
        let supplyTypeLabel = '';
        const isFixedPieces = supplyType === 'fixed-2m';

        if (supplyType === '3m') {
            supplyTypeLabel = 'Barre da 3 Metri';
            finalQuantity = quantity * 3; // Convert to meters
            guarnizioneQuantity = quantity * 3; // Guarnizione in meters
        } else if (supplyType === '6m') {
            supplyTypeLabel = 'Barre da 6 Metri';
            finalQuantity = quantity * 6; // Convert to meters
            guarnizioneQuantity = quantity * 6; // Guarnizione in meters
        } else if (supplyType === 'fixed-2m') {
            supplyTypeLabel = 'Pezzi Fissi da 2 Metri';
            // For fixed 2m pieces: keep quantity as pieces (not meters)
            finalQuantity = quantity; // Keep as pieces
            guarnizioneQuantity = quantity * 2; // Guarnizione: pezzi × 2 metri
        } else if (supplyType === 'misura') {
            supplyTypeLabel = 'Tagliato a Misura';
            if (customBars.length > 0) {
                const totalMm = customBars.reduce((sum, bar) => sum + ((bar.quantity || 0) * (bar.length || 0)), 0);
                finalQuantity = parseFloat((totalMm / 1000).toFixed(3)); // Convert to meters
                guarnizioneQuantity = finalQuantity; // Guarnizione same as main product
            }
        }

        // Add main coverstrip product
        const ralInfo = ralCode ? ` - ${ralCode}` : '';
        products.push({
            code: finalCode,
            quantity: finalQuantity,
            description: `${selectedType.label} - ${supplyTypeLabel} - ${finishConfig?.name || finish}${ralInfo} (${profileConfig.label})`,
            category: 'main',
            type: selectedType.value,
            profile: selectedProfile,
            glassOption: glassThickness,
            ralCode: ralCode || null,
            unit: isFixedPieces ? 'pezzi' : 'metri' // Add unit indicator
        });

        // Auto-add guarnizione based on glass thickness and profile-specific rules
        const glassOptions = getGlassOptions();
        const selectedGlassOption = glassOptions.find(g => g.value === glassThickness);

        if (selectedGlassOption && selectedGlassOption.guarnizione) {
            const guarnizioneLabel = selectedGlassOption.guarnizione === 'N6-G1' ? 'Piccola' : 'Grande';
            products.push({
                code: selectedGlassOption.guarnizione,
                quantity: guarnizioneQuantity, // Use separate guarnizione quantity
                description: `Guarnizione ${guarnizioneLabel} (Aggiunta automatica${glassThickness !== 'none' ? ` per ${glassThickness}` : ''}${isFixedPieces ? ` - ${guarnizioneQuantity} metri per ${quantity} pezzi` : ''})`,
                category: 'automatic',
                type: 'guarnizione',
                profile: selectedProfile,
                glassOption: glassThickness,
                unit: 'metri' // Guarnizione always in meters
            });
        }

        // Add kit distanziale for NINFA 186 asolato types if requested
        if (selectedProfile === '186' && isAsolatoType() && needsKitDistanziale) {
            products.push({
                code: 'N186-SC-A',
                quantity: finalQuantity, // Same unit as main product (pezzi for fixed-2m)
                description: 'Kit Distanziale (Per coprifili asolati)',
                category: 'optional',
                type: 'kit-distanziale',
                profile: selectedProfile,
                unit: isFixedPieces ? 'pezzi' : 'metri' // Same unit as main product
            });
        }

        return products;
    };

    // Final submission
    const handleSubmit = () => {
        const productCodes = generateProductCodes();
        const coverStripConfig = {
            selectedProfile,
            selectedType,
            supplyType,
            finish,
            ralCode: ralCode || null,
            glassThickness,
            quantity,
            customBars: supplyType === 'misura' ? customBars : undefined,
            needsKitDistanziale: isAsolatoType() && needsKitDistanziale,
            productCodes,
            profileType: selectedProfile
        };

        onSelect(coverStripConfig);
    };

    // Render steps
    const renderStep = () => {
        switch (step) {
            case 1:
                // Profile selection (only shown when profile is not specified)
                return (
                    <div className="text-center">
                        <h2 className="text-xl font-bold mb-4">Seleziona il Profilo NINFA</h2>
                        <p className="text-gray-600 mb-6">
                            Prima di configurare il coprifilo, seleziona il profilo NINFA
                        </p>

                        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mb-6 max-w-4xl mx-auto">
                            {Object.entries(PROFILE_CONFIGS).map(([key, config]) => (
                                <button
                                    key={key}
                                    onClick={() => handleProfileSelect(key)}
                                    className={`p-4 border-2 rounded-xl ${selectedProfile === key ? 'bg-red-100 border-red-500' : 'border-gray-200 bg-white hover:border-red-500 hover:shadow-lg'} transition-all`}
                                >
                                    <div className="flex flex-col items-center">
                                        <div className="w-full h-16 flex items-center justify-center mb-2">
                                            <img
                                                src={config.profileImage}
                                                alt={config.label}
                                                className="h-14 object-contain"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = '/images/placeholder.svg';
                                                }}
                                            />
                                        </div>
                                        <span className="font-medium text-gray-700">{config.label}</span>
                                        <span className="text-xs text-gray-500">
                                            {config.types.length} {config.types.length === 1 ? 'tipo' : 'tipi'}
                                        </span>
                                    </div>
                                </button>
                            ))}
                        </div>
                    </div>
                );

            case 2:
                // Type selection
                return (
                    <div className="text-center">
                        <h2 className="text-xl font-bold mb-4">Seleziona il Tipo di Coprifilo</h2>
                        <p className="text-gray-600 mb-6">
                            {profileConfig?.label} - Scegli il tipo di coprifilo
                        </p>

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6 max-w-4xl mx-auto">
                            {profileConfig?.types.map((type) => (
                                <button
                                    key={type.value}
                                    onClick={() => handleTypeSelect(type)}
                                    className={`p-4 border-2 rounded-xl ${selectedType?.value === type.value ? 'bg-red-100 border-red-500' : 'border-gray-300 hover:border-red-300 hover:shadow-lg'} transition-all`}
                                >
                                    <div className="flex flex-col items-center">
                                        {type.image ? (
                                            <div className="w-full h-20 flex items-center justify-center mb-2">
                                                <img
                                                    src={type.image}
                                                    alt={type.label}
                                                    className="h-16 object-contain"
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = '/images/placeholder.svg';
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <div className="w-16 h-16 flex items-center justify-center mb-2 bg-red-50 rounded-full">
                                                <span className="text-lg font-bold text-red-600">
                                                    {type.baseCode.split('-')[1]}
                                                </span>
                                            </div>
                                        )}
                                        <span className="font-medium text-center text-sm">{type.label}</span>
                                        <span className="text-xs text-gray-500 mt-1">{type.baseCode}*</span>
                                    </div>
                                </button>
                            ))}
                        </div>

                        {!normalizedProfileType && (
                            <div className="flex justify-center space-x-4 mt-6">
                                <button
                                    onClick={() => setStep(1)}
                                    className="px-6 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
                                >
                                    Indietro
                                </button>
                            </div>
                        )}
                    </div>
                );

            case 3:
                // Supply type selection
                return (
                    <div className="text-center">
                        <h2 className="text-xl font-bold mb-4">Seleziona il Tipo di Fornitura</h2>
                        <p className="text-gray-600 mb-6">Scegli la lunghezza delle barre o tagliato a misura</p>

                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6 max-w-3xl mx-auto">
                            {SUPPLY_TYPE_OPTIONS.map((option) => (
                                <button
                                    key={option.value}
                                    onClick={() => handleSupplyTypeSelect(option.value)}
                                    className={`p-4 border-2 rounded-lg ${supplyType === option.value ? 'bg-red-100 border-red-500' : 'border-gray-300 hover:border-red-300'}`}
                                >
                                    <div className="flex flex-col items-center">
                                        <div className="w-16 h-16 flex items-center justify-center mb-2 bg-red-50 rounded-full">
                                            <span className="text-lg font-bold">{option.icon}</span>
                                        </div>
                                        <span className="font-medium">{option.label}</span>
                                    </div>
                                </button>
                            ))}
                        </div>

                        <div className="flex justify-center space-x-4 mt-6">
                            <button
                                onClick={() => setStep(2)}
                                className="px-6 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
                            >
                                Indietro
                            </button>
                        </div>
                    </div>
                );

            case 4:
                // Finish selection
                return (
                    <div className="text-center">
                        <h2 className="text-xl font-bold mb-4">Seleziona la Finitura</h2>
                        <p className="text-gray-600 mb-6">Scegli la finitura per il coprifilo</p>

                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-6">
                            {FINISH_OPTIONS.map((finishOption) => (
                                <button
                                    key={finishOption.code}
                                    onClick={() => handleFinishSelect(finishOption.code)}
                                    className={`p-4 border rounded-lg ${finish === finishOption.code ? 'bg-red-100 border-red-500' : 'border-gray-300'}`}
                                >
                                    <div className="flex flex-col items-center">
                                        <div
                                            className="w-16 h-16 rounded-full mb-2 border border-gray-300"
                                            style={{ backgroundColor: finishOption.color }}
                                        ></div>
                                        <span className="font-medium">{finishOption.name}</span>
                                        <span className="text-sm text-gray-500">{finishOption.suffix}</span>
                                    </div>
                                </button>
                            ))}
                        </div>

                        <div className="flex justify-center space-x-4 mt-6">
                            <button
                                onClick={() => setStep(3)}
                                className="px-6 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
                            >
                                Indietro
                            </button>
                        </div>
                    </div>
                );

            case 5:
                // Glass thickness selection
                const glassOptions = getGlassOptions();
                return (
                    <div className="text-center">
                        <h2 className="text-xl font-bold mb-4">Seleziona lo Spessore Vetro</h2>
                        <p className="text-gray-600 mb-6">Scegli lo spessore del vetro</p>

                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6 max-w-3xl mx-auto">
                            {glassOptions.map((glass) => (
                                <button
                                    key={glass.value}
                                    onClick={() => handleGlassSelect(glass.value)}
                                    className={`p-4 border-2 rounded-lg ${glassThickness === glass.value ? 'bg-red-100 border-red-500' : 'border-gray-300 hover:border-red-300'}`}
                                >
                                    <div className="flex flex-col items-center">
                                        <div className="w-16 h-16 flex items-center justify-center mb-2 bg-red-50 rounded-full">
                                            <span className="text-lg font-bold">{glass.value === 'none' ? '—' : glass.value}</span>
                                        </div>
                                        <span className="font-medium">{glass.label}</span>
                                        {glass.guarnizione && (
                                            <span className="text-xs text-orange-600 mt-1">
                                                + {glass.guarnizione} auto
                                            </span>
                                        )}
                                    </div>
                                </button>
                            ))}
                        </div>

                        <div className="flex justify-center space-x-4 mt-6">
                            <button
                                onClick={() => setStep(supplyType === 'misura' ? 8 : 4)}
                                className="px-6 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
                            >
                                Indietro
                            </button>
                        </div>
                    </div>
                );

            case 6:
                // Quantity configuration (for barre and fixed-2m pieces)
                return (
                    <div className="text-center">
                        <h2 className="text-xl font-bold mb-4">Configura la Quantità</h2>

                        {supplyType === 'fixed-2m' && (
                            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4 max-w-2xl mx-auto">
                                <div className="flex items-center mb-2">
                                    <svg className="w-5 h-5 text-red-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    <h4 className="font-medium text-red-900">Info</h4>
                                </div>
                                <p className="text-sm text-red-800">
                                    I coprifili asolati sono disponibili solo in pezzi fissi da 2 metri
                                </p>
                            </div>
                        )}

                        <div className="max-w-md mx-auto p-4 border-2 rounded-lg border-gray-200 mb-6">
                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Quantità (numero di {supplyType === 'fixed-2m' ? 'pezzi da 2m' : 'barre'}):
                                </label>
                                <input
                                    type="number"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    min="1"
                                    value={quantity ?? ''}
                                    onChange={handleQuantityChange}
                                    className="w-full p-3 text-base border rounded-md text-center"
                                />
                            </div>
                        </div>

                        <div className="bg-gray-50 p-4 rounded-lg mb-6 max-w-2xl mx-auto">
                            <h3 className="font-medium mb-2">Riepilogo Prodotti</h3>
                            {generateProductCodes().map((product, index) => (
                                <div key={index} className={`text-sm mb-2 ${product.category === 'automatic' ? 'text-orange-600' : product.category === 'optional' ? 'text-red-600' : ''}`}>
                                    <span className="font-medium">{product.code}</span> -
                                    Qty: {product.quantity} {product.unit || 'metri'} - {product.description}
                                    {product.category === 'automatic' && (
                                        <span className="ml-2 text-xs bg-orange-100 px-2 py-1 rounded">Auto</span>
                                    )}
                                    {product.category === 'optional' && (
                                        <span className="ml-2 text-xs bg-red-100 px-2 py-1 rounded">Opzionale</span>
                                    )}
                                </div>
                            ))}
                        </div>

                        <div className="flex justify-center space-x-4 mt-6">
                            <button
                                onClick={() => {
                                    // Go back to kit distanziale if applicable, otherwise to glass selection
                                    if (selectedProfile === '186' && isAsolatoType()) {
                                        setStep(9);
                                    } else {
                                        setStep(5);
                                    }
                                }}
                                className="px-6 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
                            >
                                Indietro
                            </button>
                            <button
                                onClick={handleSubmit}
                                disabled={!quantity || quantity === '' || parseInt(quantity) < 1}
                                className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Aggiungi al Carrello
                            </button>
                        </div>
                    </div>
                );

            case 7:
                // Custom bars input for "Tagliato a Misura"
                return (
                    <div className="bg-white rounded-lg shadow p-6">
                        <h2 className="text-xl font-semibold text-center mb-2">
                            Tagliato a Misura
                        </h2>
                        <p className="text-gray-600 text-center mb-6">
                            Aggiungi le barre di cui hai bisogno con il pulsante "+"
                        </p>
                        <div className="space-y-6">
                            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                                <div className="flex items-center mb-3">
                                    <svg className="w-5 h-5 text-red-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    <h4 className="font-medium text-red-900">Esempio</h4>
                                </div>
                                <p className="text-sm text-red-800">
                                    3 barre da 2900mm, 5 barre da 5500mm, 1 barra da 1000mm
                                </p>
                            </div>

                            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                                <div className="flex items-center mb-2">
                                    <svg className="w-5 h-5 text-yellow-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                                    </svg>
                                    <h4 className="font-medium text-yellow-900">Restrizioni</h4>
                                </div>
                                <p className="text-sm text-yellow-800">
                                    Non puoi inserire esattamente 3000mm, 6000mm o valori maggiori di 6000mm
                                </p>
                            </div>

                            {/* Bar rows */}
                            <div className="space-y-3">
                                {customBars.map((bar, index) => (
                                    <div key={index} className="flex items-center gap-3">
                                        <div className="flex-1">
                                            <input
                                                type="number"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                min="1"
                                                max="100"
                                                value={bar.quantity === '' ? '' : (bar.quantity || '')}
                                                onChange={(e) => {
                                                    const raw = e.target.value;
                                                    const newBars = [...customBars];
                                                    newBars[index].quantity = raw === '' ? '' : Math.max(1, parseInt(raw) || 1);
                                                    setCustomBars(newBars);
                                                }}
                                                className="w-full p-3 text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
                                                placeholder="N° barre"
                                            />
                                        </div>
                                        <span className="text-gray-500 font-medium">barre da</span>
                                        <div className="flex-1">
                                            <input
                                                type="number"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                min="1"
                                                max="5999"
                                                value={bar.length || ''}
                                                onChange={(e) => {
                                                    const raw = e.target.value;
                                                    const newBars = [...customBars];
                                                    if (raw === '') {
                                                        newBars[index].length = '';
                                                        setCustomBars(newBars);
                                                        return;
                                                    }
                                                    const lengthValue = parseInt(raw) || 0;

                                                    // Validate: cannot be exactly 3000, 6000, or greater than 6000
                                                    if (lengthValue === 3000 || lengthValue === 6000 || lengthValue > 6000) {
                                                        e.target.classList.add('border-red-500', 'bg-red-50');
                                                        setTimeout(() => {
                                                            e.target.classList.remove('border-red-500', 'bg-red-50');
                                                        }, 1000);
                                                        return;
                                                    }

                                                    newBars[index].length = lengthValue;
                                                    setCustomBars(newBars);
                                                }}
                                                className="w-full p-3 text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
                                                placeholder="Millimetri"
                                            />
                                        </div>
                                        <span className="text-gray-500 font-medium">mm</span>
                                        <button
                                            onClick={() => {
                                                const newBars = customBars.filter((_, i) => i !== index);
                                                setCustomBars(newBars);
                                            }}
                                            className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                                            title="Rimuovi"
                                        >
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                            </svg>
                                        </button>
                                    </div>
                                ))}
                            </div>

                            {/* Add bar button */}
                            <button
                                onClick={() => {
                                    const newBars = [...customBars, { quantity: 1, length: 0 }];
                                    setCustomBars(newBars);
                                }}
                                className="w-full p-3 border-2 border-dashed border-gray-300 rounded-lg text-gray-600 hover:border-red-400 hover:text-red-600 transition-colors flex items-center justify-center gap-2"
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                </svg>
                                Aggiungi Barra
                            </button>

                            {/* Summary */}
                            {customBars.length > 0 && (
                                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                                    <h4 className="font-medium text-gray-900 mb-2">Riepilogo:</h4>
                                    <div className="space-y-1 text-sm text-gray-700">
                                        {customBars.map((bar, idx) => (
                                            <div key={idx}>
                                                • {bar.quantity || 0} {bar.quantity === 1 ? 'barra' : 'barre'} da {bar.length || 0}mm
                                            </div>
                                        ))}
                                        <div className="pt-2 mt-2 border-t border-gray-300 font-medium">
                                            Totale: {customBars.reduce((sum, bar) => sum + (bar.quantity || 0), 0)} barre
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="flex justify-between">
                                <button
                                    onClick={() => setStep(3)}
                                    className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
                                >
                                    Indietro
                                </button>
                                <button
                                    onClick={() => {
                                        // Validate that we have at least one bar with valid data
                                        const invalidBars = customBars.filter(bar =>
                                            bar.length === 3000 || bar.length === 6000 || bar.length > 6000
                                        );

                                        if (invalidBars.length > 0) {
                                            alert('Errore: Non puoi inserire barre di esattamente 3000mm, 6000mm o maggiori di 6000mm');
                                            return;
                                        }

                                        const validBars = customBars.filter(bar => bar.quantity > 0 && bar.length > 0);
                                        if (validBars.length > 0) {
                                            setCustomBars(validBars);
                                            setStep(4); // Go to finish selection
                                        } else {
                                            alert('Aggiungi almeno una barra con quantità e lunghezza valide');
                                        }
                                    }}
                                    className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors disabled:opacity-50"
                                    disabled={customBars.length === 0}
                                >
                                    Avanti
                                </button>
                            </div>
                        </div>
                    </div>
                );

            case 8:
                // Glass selection for "Tagliato a Misura" (after finish selection)
                const glassOpts = getGlassOptions();
                return (
                    <div className="text-center">
                        <h2 className="text-xl font-bold mb-4">Seleziona lo Spessore Vetro</h2>
                        <p className="text-gray-600 mb-6">Scegli lo spessore del vetro</p>

                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6 max-w-3xl mx-auto">
                            {glassOpts.map((glass) => (
                                <button
                                    key={glass.value}
                                    onClick={() => {
                                        setGlassThickness(glass.value);

                                        // For NINFA 186 asolato types, ask about kit distanziale
                                        if (selectedProfile === '186' && isAsolatoType()) {
                                            setStep(9);
                                        } else {
                                            setStep(10); // Go to final review
                                        }
                                    }}
                                    className={`p-4 border-2 rounded-lg ${glassThickness === glass.value ? 'bg-red-100 border-red-500' : 'border-gray-300 hover:border-red-300'}`}
                                >
                                    <div className="flex flex-col items-center">
                                        <div className="w-16 h-16 flex items-center justify-center mb-2 bg-red-50 rounded-full">
                                            <span className="text-lg font-bold">{glass.value === 'none' ? '—' : glass.value}</span>
                                        </div>
                                        <span className="font-medium">{glass.label}</span>
                                        {glass.guarnizione && (
                                            <span className="text-xs text-orange-600 mt-1">
                                                + {glass.guarnizione} auto
                                            </span>
                                        )}
                                    </div>
                                </button>
                            ))}
                        </div>

                        <div className="flex justify-center space-x-4 mt-6">
                            <button
                                onClick={() => setStep(4)}
                                className="px-6 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
                            >
                                Indietro
                            </button>
                        </div>
                    </div>
                );

            case 9:
                // Kit distanziale selection (only for NINFA 186 asolato types)
                return (
                    <div className="text-center">
                        <h2 className="text-xl font-bold mb-4">Kit Distanziale</h2>
                        <p className="text-gray-600 mb-6">
                            Per i coprifili asolati NINFA 186, è necessario il kit distanziale?
                        </p>

                        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6 max-w-2xl mx-auto">
                            <div className="flex items-center mb-2">
                                <svg className="w-5 h-5 text-red-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <h4 className="font-medium text-red-900">Nota</h4>
                            </div>
                            <p className="text-sm text-red-800">
                                Il kit distanziale (N186-SC-A) è da abbinare ai coprifili asolati solo se richiesto
                            </p>
                        </div>

                        <div className="grid grid-cols-2 gap-4 mb-6 max-w-md mx-auto">
                            <button
                                onClick={() => {
                                    setNeedsKitDistanziale(true);
                                    setStep(supplyType === 'misura' ? 10 : 6);
                                }}
                                className={`p-6 border-2 rounded-lg ${needsKitDistanziale ? 'bg-red-100 border-red-500' : 'border-gray-300 hover:border-red-300'}`}
                            >
                                <div className="text-xl font-bold mb-2">Sì</div>
                                <div className="text-sm text-gray-600">Aggiungi kit distanziale</div>
                            </button>
                            <button
                                onClick={() => {
                                    setNeedsKitDistanziale(false);
                                    setStep(supplyType === 'misura' ? 10 : 6);
                                }}
                                className={`p-6 border-2 rounded-lg ${!needsKitDistanziale ? 'bg-red-100 border-red-500' : 'border-gray-300 hover:border-red-300'}`}
                            >
                                <div className="text-xl font-bold mb-2">No</div>
                                <div className="text-sm text-gray-600">Non necessario</div>
                            </button>
                        </div>

                        <div className="flex justify-center space-x-4 mt-6">
                            <button
                                onClick={() => setStep(supplyType === 'misura' ? 8 : 5)}
                                className="px-6 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
                            >
                                Indietro
                            </button>
                        </div>
                    </div>
                );

            case 10:
                // Final review for "Tagliato a Misura"
                return (
                    <div className="text-center">
                        <h2 className="text-xl font-bold mb-4">Riepilogo Finale</h2>

                        <div className="bg-gray-50 p-4 rounded-lg mb-6 max-w-2xl mx-auto">
                            <h3 className="font-medium mb-4">Prodotti da Aggiungere</h3>
                            {generateProductCodes().map((product, index) => (
                                <div key={index} className={`text-sm mb-2 p-2 bg-white rounded ${product.category === 'automatic' ? 'text-orange-600' : product.category === 'optional' ? 'text-red-600' : ''}`}>
                                    <div className="font-medium">{product.code}</div>
                                    <div>Quantità: {product.quantity} {product.unit || 'metri'}</div>
                                    <div>{product.description}</div>
                                    {product.category === 'automatic' && (
                                        <span className="text-xs bg-orange-100 px-2 py-1 rounded mt-1 inline-block">Aggiunta Automatica</span>
                                    )}
                                    {product.category === 'optional' && (
                                        <span className="text-xs bg-red-100 px-2 py-1 rounded mt-1 inline-block">Opzionale</span>
                                    )}
                                </div>
                            ))}
                        </div>

                        <div className="flex justify-center space-x-4 mt-6">
                            <button
                                onClick={() => {
                                    // Go back to kit distanziale if applicable, otherwise to glass selection
                                    if (selectedProfile === '186' && isAsolatoType()) {
                                        setStep(9);
                                    } else {
                                        setStep(8);
                                    }
                                }}
                                className="px-6 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
                            >
                                Indietro
                            </button>
                            <button
                                onClick={handleSubmit}
                                className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
                            >
                                Aggiungi al Carrello
                            </button>
                        </div>
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <div className="space-y-6">
            {renderStep()}
            <RALModal
                isOpen={showRALModal}
                onClose={handleRALClose}
                onConfirm={handleRALConfirm}
                finishType={pendingFinishCode}
            />
        </div>
    );
};

export default CoverStripSelector;
